module.exports = __webpack_public_path__ + "img/answer.f27a1f8f.svg";